import {
  collection,
  getDocs,
  doc,
  writeBatch,
} from 'firebase/firestore';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { db, auth } from '@festpix/services';

const BATCH_SIZE = 500;

export async function verifyAdminPassword(email: string, password: string): Promise<boolean> {
  try {
    await signInWithEmailAndPassword(auth, email, password);
    return true;
  } catch {
    return false;
  }
}

export async function deleteAllTransactions(): Promise<number> {
  const transactionsSnapshot = await getDocs(collection(db, 'transactions'));

  if (transactionsSnapshot.empty) {
    return 0;
  }

  let deletedCount = 0;
  let batch = writeBatch(db);
  let batchCount = 0;

  for (const docSnapshot of transactionsSnapshot.docs) {
    batch.delete(doc(db, 'transactions', docSnapshot.id));
    batchCount++;
    deletedCount++;

    if (batchCount >= BATCH_SIZE) {
      await batch.commit();
      batch = writeBatch(db);
      batchCount = 0;
    }
  }

  if (batchCount > 0) {
    await batch.commit();
  }

  return deletedCount;
}

export async function resetAllBoothWalletBalances(): Promise<number> {
  const walletsSnapshot = await getDocs(collection(db, 'wallets'));

  let resetCount = 0;
  let batch = writeBatch(db);
  let batchCount = 0;

  for (const docSnapshot of walletsSnapshot.docs) {
    const walletData = docSnapshot.data();

    if (walletData.type === 'booth' || walletData.ownerId === 'booth') {
      batch.update(doc(db, 'wallets', docSnapshot.id), { balance: 0 });
      batchCount++;
      resetCount++;

      if (batchCount >= BATCH_SIZE) {
        await batch.commit();
        batch = writeBatch(db);
        batchCount = 0;
      }
    }
  }

  if (batchCount > 0) {
    await batch.commit();
  }

  return resetCount;
}

export async function resetAllSKUQuantities(): Promise<number> {
  const skusSnapshot = await getDocs(collection(db, 'skus'));

  if (skusSnapshot.empty) {
    return 0;
  }

  let resetCount = 0;
  let batch = writeBatch(db);
  let batchCount = 0;

  for (const docSnapshot of skusSnapshot.docs) {
    batch.update(doc(db, 'skus', docSnapshot.id), { quantity: 0 });
    batchCount++;
    resetCount++;

    if (batchCount >= BATCH_SIZE) {
      await batch.commit();
      batch = writeBatch(db);
      batchCount = 0;
    }
  }

  if (batchCount > 0) {
    await batch.commit();
  }

  return resetCount;
}

export async function getTransactionsCount(): Promise<number> {
  const snapshot = await getDocs(collection(db, 'transactions'));
  return snapshot.size;
}

export async function getBoothWalletsCount(): Promise<number> {
  const snapshot = await getDocs(collection(db, 'wallets'));
  let count = 0;
  snapshot.docs.forEach((doc) => {
    const data = doc.data();
    if (data.type === 'booth' || data.ownerId === 'booth') {
      count++;
    }
  });
  return count;
}

export async function getSKUsCount(): Promise<number> {
  const snapshot = await getDocs(collection(db, 'skus'));
  return snapshot.size;
}
